import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabcompaniesinmumbai() {



  const cardData =
  {
    keyword: 'Cab Companies in Mumbai ',
    heading: 'Shambhu Cabs: Cab Companies in Mumbai',
    headingDescription: 'Shambhu Cabs is one of the leading Cab Companies in Mumbai, offering safe, comfortable, and reliable transportation for families, corporate travelers, business professionals, and tourists across the city. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures smooth travel with well-maintained vehicles and spacious seating. With flexible hourly, daily, airport transfer, and intercity travel options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes city travel convenient, punctual, and stress-free. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted cab services in Mumbai for travelers seeking comfort, safety, and a dependable urban travel experience.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 to commemorate the visit of King George V and Queen Mary, is one of Mumbai’s most iconic landmarks. Located on the waterfront in Colaba, it features grand arches in Indo-Saracenic style, offering panoramic views of the Arabian Sea. The surrounding area is lively with street vendors, boat rides to Elephanta Island, and cultural performances, making it a must-visit for tourists exploring Mumbai’s heritage and coastal beauty."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km long boulevard along the Arabian Sea. Famous for its Art Deco buildings and stunning sunset views, it attracts joggers, families, and tourists. The promenade lights up at night, giving it the appearance of a string of pearls. Marine Drive is perfect for leisurely walks, photography, and experiencing Mumbai’s vibrant coastal life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, formerly Victoria Terminus, is a UNESCO World Heritage Site and one of India’s busiest railway stations. Built in 1887 in Victorian Gothic style with domes, turrets, and intricate stone carvings, it is an architectural marvel. The station symbolizes Mumbai’s colonial past and modern connectivity, serving as both a transportation hub and a tourist attraction admired for its historical and cultural significance."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple, dedicated to Lord Ganesha, is one of Mumbai’s most revered religious sites. Located in Prabhadevi, it attracts thousands of devotees daily who seek blessings and fulfillment of wishes. The temple’s idol, adorned with gold, intricate carvings, and beautiful decorations, creates a spiritual and serene atmosphere. Festivals, especially Ganesh Chaturthi, see grand celebrations, making it a cultural and religious landmark."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island near Mumbai, are UNESCO World Heritage Sites featuring rock-cut sculptures dedicated to Lord Shiva. Dating back to the 5th-8th centuries, the caves showcase intricate carvings such as the Trimurti statue, depicting the Hindu trinity. Visitors reach the island by ferry from the Gateway of India, making it a historical, cultural, and scenic destination combining art, mythology, and maritime beauty."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a mosque and tomb situated on an islet off the coast of Worli, accessible via a narrow causeway. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it attracts pilgrims and tourists from around the world. The white marble structure, set against the Arabian Sea, is especially picturesque during high tide and sunset. It is a symbol of Mumbai’s religious harmony and spiritual heritage."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, meaning 'Thieves Market,' is one of Mumbai’s oldest and largest flea markets, famous for antiques, vintage items, Bollywood memorabilia, and curiosities. The bustling market is a treasure trove for collectors, photographers, and bargain hunters. Strolling through its narrow lanes, visitors experience the vibrant chaos, history, and culture of Mumbai’s trading legacy, making it a must-visit for shoppers seeking unique finds."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its vibrant street food, sunset views, and lively atmosphere. Locals and tourists flock here to enjoy snacks like pav bhaji, bhel puri, and ice cream while walking along the shore. The beach is also home to cultural events, kite flying, and recreational activities, offering a relaxing escape from the bustling city life and a perfect spot for family outings and photography."
  },
  {
    "title": "Mount Mary Church",
    "description": "Mount Mary Basilica, located in Bandra, is a Roman Catholic church renowned for its serene ambiance, beautiful architecture, and annual Bandra Fair. The church attracts pilgrims and tourists alike, offering stunning views of the surrounding hills and sea. Its blend of Gothic and modern architecture, along with the spiritual atmosphere, makes it a must-visit destination for those exploring Mumbai’s religious and cultural heritage."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, located in the northern suburbs of Mumbai, is a lush green sanctuary spanning over 100 square kilometers. It houses diverse flora and fauna, including leopards, deer, and various bird species. The park features the Kanheri Caves, trekking trails, boating, and safari options. It serves as a natural escape from the urban hustle, offering wildlife encounters, historical exploration, and outdoor adventure for families and nature enthusiasts."
  }
],




"services": [
  {
    "name": "Best Cab Providers Mumbai",
    "description": "Best Cab Providers Mumbai connects travelers with the most reliable, professional, and customer-friendly cab services in Mumbai. This service ensures high-quality vehicles, experienced drivers, and seamless booking options for local, outstation, and airport travel. Ideal for daily commutes, corporate transport, and leisure trips, it prioritizes comfort, safety, and punctuality for every passenger."
  },
  {
    "name": "Top Cab Operators Mumbai",
    "description": "Top Cab Operators Mumbai offers premium taxi services from leading operators in the city. The service focuses on reliability, well-maintained vehicles, and professional drivers. Customers can choose from AC sedans, SUVs, and luxury cars for local, outstation, or airport transfers, ensuring a smooth and comfortable travel experience with transparent pricing and easy booking."
  },
  {
    "name": "Mumbai Taxi Companies",
    "description": "Mumbai Taxi Companies provide a wide range of taxi options for residents and visitors, including point-to-point rides, outstation trips, and airport transfers. These companies focus on safety, punctuality, and customer satisfaction, offering vehicles with trained chauffeurs, GPS tracking, and flexible packages to meet diverse travel requirements."
  },
  {
    "name": "Local Cab Companies Mumbai",
    "description": "Local Cab Companies Mumbai specialize in city commutes and short-distance travel within Mumbai. The service includes AC and non-AC cabs, hatchbacks, sedans, and SUVs, all driven by experienced drivers. Customers benefit from reliable pickups, efficient routing, and affordable fares for daily travel, sightseeing, or urgent rides."
  },
  {
    "name": "Professional Cab Firms Mumbai",
    "description": "Professional Cab Firms Mumbai deliver high-quality taxi services with an emphasis on customer satisfaction, safety, and professionalism. Their fleet includes well-maintained sedans, SUVs, and premium vehicles, driven by trained chauffeurs. Ideal for corporate travel, airport transfers, and personal rides, the service guarantees timely and hassle-free journeys."
  },
  {
    "name": "Affordable Cab Companies Mumbai",
    "description": "Affordable Cab Companies Mumbai provide cost-effective taxi solutions without compromising on quality or safety. The service offers various options, including AC sedans, SUVs, and hatchbacks, suitable for local and outstation travel. With transparent fares and flexible booking, this service is ideal for budget-conscious travelers seeking reliable transport."
  },
  {
    "name": "AC Cab Operators Mumbai",
    "description": "AC Cab Operators Mumbai focus on providing comfortable and climate-controlled rides throughout the city. The fleet includes sedans and SUVs with professional drivers, suitable for daily commutes, airport transfers, and corporate travel. Passengers enjoy a smooth, safe, and hassle-free ride experience in air-conditioned comfort."
  },
  {
    "name": "24×7 Cab Companies Mumbai",
    "description": "24×7 Cab Companies Mumbai offer round-the-clock taxi services for all travel needs, including emergencies, airport pickups, and late-night commutes. Their fleet comprises AC and non-AC cabs, SUVs, and sedans with professional chauffeurs, ensuring safety, reliability, and convenience anytime, anywhere in Mumbai."
  },
  {
    "name": "Trusted Cab Services Mumbai",
    "description": "Trusted Cab Services Mumbai are known for reliability, transparency, and customer satisfaction. With a fleet of well-maintained vehicles and experienced drivers, the service ensures timely pickups, safe travel, and affordable pricing. Ideal for local commutes, airport transfers, and intercity travel, it emphasizes a hassle-free and secure experience for passengers."
  },
  {
    "name": "Mumbai Corporate Cab Companies",
    "description": "Mumbai Corporate Cab Companies provide tailored transportation solutions for businesses and corporate clients. Services include employee commute, client pickups, airport transfers, and intercity business travel. With sedans, SUVs, and luxury vehicles, professional chauffeurs, and flexible plans, corporate clients receive a safe, punctual, and comfortable travel experience."
  },
  {
    "name": "Verified Cab Companies Mumbai",
    "description": "Verified Cab Companies Mumbai ensure high standards of safety, vehicle quality, and driver professionalism. Each cab and driver undergoes rigorous verification processes, offering passengers a secure and reliable travel experience. The service is ideal for daily commutes, airport transfers, and long-distance journeys with guaranteed peace of mind."
  },
  {
    "name": "Mumbai Travel Cab Agencies",
    "description": "Mumbai Travel Cab Agencies specialize in comprehensive taxi services, including sightseeing, airport transfers, outstation trips, and city commutes. The fleet consists of well-maintained sedans, SUVs, and luxury vehicles, with professional drivers ensuring punctuality, comfort, and safety for all kinds of travelers, from tourists to business clients."
  },
  {
    "name": "Best Rated Cab Companies Mumbai",
    "description": "Best Rated Cab Companies Mumbai are recognized for their exceptional customer service, safety, and reliability. With high ratings from users, these companies offer a fleet of sedans, SUVs, and luxury cars, professional chauffeurs, and convenient online booking. Ideal for both daily travel and outstation trips, they guarantee satisfaction for every ride."
  },
  {
    "name": "Car Rental Companies Mumbai",
    "description": "Car Rental Companies Mumbai provide a range of vehicles for self-drive or chauffeur-driven rental options. From sedans and SUVs to luxury cars, travelers can choose vehicles based on budget, comfort, and travel needs. The service includes flexible rental durations, 24×7 support, and well-maintained vehicles for safe and convenient transportation."
  },
  {
    "name": "Online Cab Operators Mumbai",
    "description": "Online Cab Operators Mumbai allow customers to book taxis conveniently through websites or mobile apps. Services include local rides, airport transfers, and outstation trips, with transparent pricing, real-time tracking, and professional drivers. This service ensures hassle-free booking, timely pickups, and reliable travel throughout Mumbai and beyond."
  },
  {
    "name": "Taxi Service Companies Mumbai",
    "description": "Taxi Service Companies Mumbai offer comprehensive transportation solutions, including city cabs, outstation trips, airport pickups, and corporate travel. The service ensures well-maintained vehicles, trained drivers, and prompt service. With a focus on safety, convenience, and affordability, these companies cater to both personal and professional travel needs."
  },
  {
    "name": "Fast Cab Companies Mumbai",
    "description": "Fast Cab Companies Mumbai specialize in quick, efficient, and reliable taxi services across Mumbai. With professional drivers, well-maintained vehicles, and optimized routes, the service ensures minimal waiting time and prompt arrivals. Ideal for urgent rides, airport transfers, and time-sensitive travel, passengers can rely on speedy and comfortable journeys."
  }
],

"tableData": [
  ["Best Cab Providers Mumbai", "Top Cab Operators Mumbai"],
  ["Mumbai Taxi Companies", "Local Cab Companies Mumbai"],
  ["Professional Cab Firms Mumbai", "Affordable Cab Companies Mumbai"],
  ["AC Cab Operators Mumbai", "24×7 Cab Companies Mumbai"],
  ["Trusted Cab Services Mumbai", "Mumbai Corporate Cab Companies"],
  ["Verified Cab Companies Mumbai", "Mumbai Travel Cab Agencies"],
  ["Best Rated Cab Companies Mumbai", "Car Rental Companies Mumbai"],
  ["Online Cab Operators Mumbai", "Taxi Service Companies Mumbai"],
  ["Fast Cab Companies Mumbai", "—"]
],



"whychoose": [
  {
    "WhyChooseheading": "Cab Companies in Mumbai – Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs is one of the trusted cab companies in Mumbai, offering reliable services for airport transfers, city travel, and intercity journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs, ensuring a safe and comfortable ride across Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai Routes",
    "WhyChoosedescription": "Our professional drivers know all major routes and traffic patterns in Mumbai, guaranteeing timely, smooth, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide upfront pricing—fuel, tolls, and driver allowances included—so your cab experience in Mumbai is stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Every Need",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans designed to meet your travel requirements in Mumbai."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip, ensuring a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and smooth service, making your travel with Shambhu Cabs comfortable and worry-free."
  }
]





















  }

const faqData = [
  {
    question: 'Is Shambhu Cabs one of the top cab companies in Mumbai?',
    answer: 'Yes, Shambhu Cabs is among the leading cab companies in Mumbai, offering reliable, safe, and comfortable cab services for local and outstation travel.',
  },
  {
    question: 'How can I book a cab with Shambhu Cabs, one of the top cab companies in Mumbai?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for seamless booking.',
  },
  {
    question: 'What types of vehicles are offered by Shambhu Cabs in Mumbai?',
    answer: 'Shambhu Cabs provides a wide range of vehicles including sedans, SUVs, and luxury cars suitable for individual, family, and corporate travel in Mumbai.',
  },
  {
    question: 'Are drivers experienced with cab services in Mumbai?',
    answer: 'Yes, our drivers are licensed, professional, and knowledgeable about Mumbai city routes to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations with Shambhu Cabs?',
    answer: 'Absolutely. You can select any pickup and drop-off points anywhere in Mumbai according to your convenience.',
  },
  {
    question: 'Is the cab service available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs operates round-the-clock, providing cab services at any time of day or night.',
  },
  {
    question: 'Are safety and hygiene protocols followed by Shambhu Cabs?',
    answer: 'All vehicles are regularly sanitized, and drivers follow strict hygiene and safety protocols for passenger well-being.',
  },
  {
    question: 'What payment options are available with Shambhu Cabs in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
  },
  {
    question: 'Is customer support available during cab journeys in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your travel with Shambhu Cabs in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Mehra',
    feedback: 'Shambhu Cabs is one of the most reliable cab companies in Mumbai. The drivers are professional, and the vehicles are well-maintained.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Kapoor',
    feedback: 'Highly satisfied with Shambhu Cabs! Timely, comfortable, and safe cab service in Mumbai.',
    rating: 5,
  },
];





















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Companies in Mumbai",
  "image": "https://www.shambhucab.com/assets/images/cab-companies-mumbai.jpg",
  "description": "Shambhu Cabs is one of the leading cab companies in Mumbai, offering professional, reliable, and affordable taxi services. From local city rides to corporate travel, AC cabs, and online booking, we provide 24×7 trusted services for all your transportation needs.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "350",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/cab-companies-mumbai"
  }
};





  return (
    <div>
<Helmet>
  <title>Cab Companies in Mumbai | Top & Trusted Taxi Services | Shambhu Cabs</title>

  <meta
    name="description"
    content="Shambhu Cabs is a top cab company in Mumbai offering professional, reliable, and affordable taxi services. AC cabs, corporate travel, local rides, and online booking available 24×7 for all your transportation needs."
  />

  <meta
    name="keywords"
    content="Best Cab Providers Mumbai, Top Cab Operators Mumbai, Mumbai Taxi Companies, Local Cab Companies Mumbai, Professional Cab Firms Mumbai, Affordable Cab Companies Mumbai, AC Cab Operators Mumbai, 24×7 Cab Companies Mumbai, Trusted Cab Services Mumbai, Mumbai Corporate Cab Companies, Verified Cab Companies Mumbai, Mumbai Travel Cab Agencies, Best Rated Cab Companies Mumbai, Car Rental Companies Mumbai, Online Cab Operators Mumbai, Taxi Service Companies Mumbai, Fast Cab Companies Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/35.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabcompaniesinmumbai;